import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  Box,
  Paper,
  Avatar,
  Button,
  IconButton,
} from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { deepPurple } from "@mui/material/colors";
import { useUser } from "../Contexts/UserContext";
import { useNavigate } from "react-router-dom";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const getRandomColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
const RepairCard = ({ feedbacks }) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const { user } = useUser();
  const { CompCode, ClientId } = user;
  const [rawData, setRawData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchInitData = async () => {
      const result = await fetch(
        `${API_URL}/facility/GetRepairMaintenanceData/1/${CompCode}/${ClientId}/UNTAPS009482`
      ).then((res) => res.json());
      if (result.success) {
        setRawData(result.data);
      } else {
        // alert("Error in fetching repair data");
      }
    };
    fetchInitData();
  }, [ClientId]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginatedFeedbacks = rawData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Card sx={{ margin: "auto" }}>
      <CardContent>
        <Typography
          variant="h6"
          component="div"
          gutterBottom
          onClick={() => navigate("/RMPAge")}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Repair And Maintenance ({feedbacks.length})
          {/* <IconButton
            color="primary"
            aria-label="user avatar"
            onClick={() => navigate("/detail")}
          >
            <Avatar
              sx={{
                bgcolor: "red",
                width: 30,
                height: 30,
              }}
            >
              ➜
            </Avatar>
          </IconButton> */}
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              {paginatedFeedbacks.length === 0 && (
                <TableRow key={0}>
                  <TableCell sx={{ padding: "10px" }}>
                    <Box display="flex" alignItems="center">
                      <Box>
                        <Typography variant="body1" component="div">
                          No Data Found
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
              {paginatedFeedbacks.map((feedback, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ padding: "10px" }}>
                    <Box display="flex" alignItems="center">
                      <Box>
                        <Typography variant="body1" component="div">
                          Need Repair And Maint.. for {feedback.Checklist_name}
                        </Typography>
                        <Typography variant="caption" color="textSecondary">
                          {feedback.SiteCode}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(feedbacks.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            color="primary"
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default RepairCard;
